// Libraries
import React from 'react';
import { get } from 'lodash';
import { useMutation } from 'react-apollo';
import { loader } from 'graphql.macro';
import { useDispatch } from 'react-redux';

// Services
import { updateLoader } from '@services/loader';

// Hooks
import { useGetBoards } from '@hooks/data';

// GraphQL
const query = loader('src/graphql/mutations/updateBoard.gql');

type PROPS_TYPE = {
  isLoader?: Boolean,
  onLoad?: Function
};

export const useUpdateBoard = ({ isLoader = true }: PROPS_TYPE = {}) => {

  const dispatch = useDispatch();

  const [normalized, setNormalized] = React.useState();

  const {
    load: loadBoards,
    loading: loadingBoards,
    result: resultBoards,
    error: errorBoards,
  } = useGetBoards();

  const [load, {
    loading,
    data,
    error
  }] = useMutation(query, {
    fetchPolicy: 'no-cache',
    onError: error => {}
  });

  React.useEffect(() => {
    isLoader && dispatch(updateLoader({ loading: isLoader }));
  }, [loading]);

  React.useEffect(() => {
    if (loading || !data) { return; }
    loadBoards({ isLoader });
  }, [loading, data]);


  React.useEffect(() => {
    if (loadingBoards || !resultBoards) { return; }
    // onLoad(resultBoards, dispatch);
    setNormalized(get(data, 'wikiPage'));
  }, [loadingBoards, resultBoards]);

  return {
    load,
    loading,
    result: normalized,
    error: error || errorBoards,
  };
};

export default useUpdateBoard;
